import * as React from "react";
import { Label } from "@fluentui/react-components";
import PropTypes from "prop-types";

export const FluentLabel = ({ label, required, className }) => (
  <Label required={required} weight="semibold" className={className}>
    {label}
  </Label>
);

FluentLabel.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  required: PropTypes.bool,
};
